export const DefaultStateAnimateConfig = {
    duration: 200,
    easing: "cubicOut"
};

export const DefaultMorphingAnimateConfig = {
    duration: 1e3,
    easing: "quadInOut"
};